// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1u9-1","textarea":"styles_textarea__32qL0"};